<template>
    <p>
        Affected Hosts:
        <span v-for="(host, index) in getHosts()">
            <a :href="detailRoute(host)">{{ host.name }}</a><span v-if="index < (getHosts().length - 1)">, </span>
        </span>
        <span v-if="hosts.length > 3" v-html="' and '+ (hosts.length - 3) +' other Hosts'"></span>
    </p>
</template>

<script>
    export default {
        props: {
            hosts: {
                required: true,
                type: Array,
            },
        },
        methods: {
            detailRoute(host) {
                return route('host', {
                    hostID: host.id
                });
            },
            getHosts() {
                return this.hosts.slice(0, 3);
            },
            moreHosts() {
                return this.hosts.length > 3;
            }
        }
    }
</script>
